(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5914],{

/***/ 65655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/th.js
var th = __webpack_require__(62019);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/buddhistEra.js
var buddhistEra = __webpack_require__(40683);
var buddhistEra_default = /*#__PURE__*/__webpack_require__.n(buddhistEra);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.mjs
var fa = __webpack_require__(52091);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(15072);
// EXTERNAL MODULE: ./src/utils/datalayer/send-datalayer.js
var send_datalayer = __webpack_require__(34892);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/services/member-auth/components/forms/checkbox-form.jsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  width: 100%;\n  input:disabled {\n    cursor: no-drop;\n    background-color: rgba(239, 239, 239, 0.3) !important;\n    border-color: rgba(118, 118, 118, 0.3) !important;\n  }\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition: background-color 9999s ease-in-out 0s;\n  }\n\n  .label-form {\n    line-height: 1;\n    padding: 0 0 0 5px;\n    font-size: 16px;\n    color: rgb(0, 0, 0, 0.6);\n    transition: all ease-in-out 0.2s;\n  }\n\n  .input-form {\n    display: flex;\n    align-items: center;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background: transparent;\n    border-radius: 10px;\n    border: 1px solid rgb(0, 0, 0, 0.3);\n    box-sizing: border-box;\n    padding: 10px;\n    outline: none;\n    color: #000;\n    font-size: 16px;\n    padding-left: 30px;\n\n    &:hover {\n      border: 1px solid #0600E7;\n    }\n    &:focus {\n      &:invalid {\n        border: 1px solid red;\n        border-radius: 10px;\n      }\n    }\n  }\n  .input-form:focus ~ .label-form,\n  .input-form:not(:placeholder-shown) ~ .label-form {\n    transform: translateX(-30px) translateY(-35px);\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CheckboxForm = function(_param, ref) {
    var name = _param.name, label = _param.label, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
        className: "input-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "checkbox",
                id: name,
                name: name
            }, otherProps), {
                ref: ref
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "label-form",
                htmlFor: name,
                children: label
            })
        ]
    });
};
var InputWrapper = styled_components_browser_esm["default"].div(_templateObject());
/* harmony default export */ var checkbox_form = (/*#__PURE__*/(0,react.forwardRef)(CheckboxForm));

// EXTERNAL MODULE: ./src/services/member-auth/utils/decryption-payload.js
var decryption_payload = __webpack_require__(84233);
// EXTERNAL MODULE: ./src/utils/useUser.js
var useUser = __webpack_require__(51148);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.mjs
var hi = __webpack_require__(19042);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.mjs
var md = __webpack_require__(30080);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.mjs
var ri = __webpack_require__(7696);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.mjs
var bs = __webpack_require__(78633);
// EXTERNAL MODULE: ./node_modules/react-icons/fc/index.mjs
var fc = __webpack_require__(28472);
;// CONCATENATED MODULE: ./src/2.0/subscribe/widget-login-subscribe.js
/* eslint-disable no-return-assign */ /* eslint-disable multiline-ternary */ 


function widget_login_subscribe_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  padding: 8px 0 8px 16px;\n  @media (max-width: 768px) {\n    padding: 0;\n    /* padding: 8px 10px 8px 16px; */\n  }\n  &:hover {\n    .menu-list {\n      display: flex;\n    }\n    .btn-login {\n      svg {\n        color: #ffffffba;\n      }\n    }\n  }\n  /* ------------------------------ BUTTON LOGIN ------------------------------ */\n  .btn-login {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: transparent;\n\n    padding: 0;\n    border: none;\n    border-radius: 50px;\n    &.login {\n      border: 2px solid var(--text-color);\n      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));\n    }\n\n    svg {\n      color: var(--text-color);\n      @media (max-width: 690px) {\n        height: 24px;\n        width: 24px;\n      }\n    }\n  }\n\n  .info {\n    font-size: 12px;\n    font-weight: 300;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-direction: column;\n    .username,\n    .email {\n      width: 150px;\n      font-size: 14px;\n      font-weight: 400;\n      text-transform: capitalize;\n\n      padding: 5px;\n      margin: 0;\n    }\n  }\n\n  .menu-list {\n    z-index: 100 !important;\n    display: none;\n    position: absolute;\n    top: 50px;\n    right: 0;\n    background-color: #ffffff;\n    box-shadow: 1px 0px 10px 0px var(--primary-color);\n    width: max-content;\n    flex-direction: column;\n    border-radius: 5px;\n    margin: 0;\n    padding: 10px !important;\n    &:before {\n      content: '';\n      position: absolute;\n      top: -8px;\n      right: 0px;\n      width: 0;\n      height: 0;\n      border-left: 15px solid transparent;\n      border-right: 15px solid transparent;\n      border-bottom: 15px solid white;\n    }\n    @media (max-width: 767px) {\n      left: auto;\n      right: 10px;\n      top: 47px;\n      &:before {\n        top: -5px;\n        right: 10px;\n        left: auto;\n      }\n    }\n    .list-item {\n      width: 100%;\n      margin: 0;\n      a {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        svg {\n          margin-right: 5px;\n        }\n      }\n    }\n\n    svg {\n      color: var(--primary-color);\n      font-weight: 700;\n      margin-left: 5px;\n      margin-bottom: 2px;\n      transition: all 3ms ease-in;\n    }\n    li {\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      font-size: 14px;\n      font-weight: 500;\n      margin: 0;\n      padding: 8px;\n      font-family: 'DBHelvethaica', sans-serif;\n      gap: 5px;\n      z-index: 2;\n      border-radius: 5px;\n      p {\n        padding: 0;\n        margin: 0;\n        color: var(--primary-color);\n      }\n      &:hover {\n        box-shadow: 1px 0px 10px 0px rgba(237, 26, 59, 0.3);\n        background-color: var(--primary-color);\n        p,\n        svg {\n          color: #fff;\n        }\n      }\n    }\n  }\n"
    ]);
    widget_login_subscribe_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background-color: rgb(0, 0, 0, 0.5);\n  z-index: 15;\n  .bottom-line {\n    width: 100%;\n    height: 2px;\n    background-color: rgba(0, 0, 0, 0.15);\n  }\n  .modal-social {\n    background: linear-gradient(103.43deg, #f6f6f6 0%, #eeeeee 100%);\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.85);\n    border-radius: 10px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 10px;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    gap: 16px;\n    padding: 40px 30px;\n    @media (max-width: 767px) {\n      padding: 20px;\n      width: 320px;\n    }\n    @media (max-width: 380px) {\n      width: 300px;\n    }\n\n    .heading {\n      color: var(--primary-color);\n      font-size: 26px;\n      font-weight: 900;\n      display: block;\n      text-align: center;\n      margin-bottom: 10px;\n      /* border-bottom: 1px solid var(--primary-color); */\n      /* padding-bottom: 15px; */\n      @media (max-width: 767px) {\n        font-size: 24px;\n      }\n      @media (max-width: 380px) {\n        margin-top: 10px;\n        margin-bottom: 5px;\n      }\n    }\n    /* ------------------------------ BUTTON CLOSE ----------------------------- */\n    .btn-close {\n      position: absolute;\n      top: 20px;\n      right: 10px;\n      cursor: pointer;\n      border: none;\n      background-color: transparent;\n      transition: all ease 0.25ms;\n\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      svg {\n        color: var(--primary-color);\n      }\n      @media (max-width: 767px) {\n        top: 10px;\n      }\n\n      &:hover {\n        color: #474747;\n      }\n    }\n    /* ------------------------------ BUTTON SOCIAL ----------------------------- */\n    .btn-social {\n      cursor: pointer;\n      transition: background-color ease-in-out 100ms;\n      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));\n      background-color: #ffffff;\n      border-radius: 50px;\n      color: #fff;\n      border: 0;\n\n      gap: 16px;\n      padding: 16px 30px;\n\n      width: 100%;\n      max-width: 345px;\n      margin: auto;\n      height: 48px;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      @media (max-width: 767px) {\n        padding: 16px;\n      }\n      p {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 1.25;\n        color: #111;\n\n        span {\n          text-transform: capitalize;\n        }\n        @media (max-width: 767px) {\n          font-size: 16px;\n        }\n      }\n\n      &.icon-google {\n        color: #000000;\n        background: #ffffff;\n        &:hover {\n          background: #e5e5e5;\n          color: #ffffff;\n        }\n      }\n      &.icon-facebook {\n        background: #ffffff;\n        svg {\n          color: #337fff;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-line {\n        background: #ffffff;\n        svg {\n          color: #3ace01;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-tiktok {\n        background: #ffffff;\n        svg {\n          color: #000;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n      &.icon-linkin {\n        background: #ffffff;\n        svg {\n          color: #337fff;\n        }\n        &:hover {\n          background: #e5e5e5;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100px;\n  height: 100px;\n  align-self: center;\n  margin: 10px 50px;\n  .circle {\n    height: 100%;\n    right: 0px;\n    position: absolute;\n    border: solid 15px #a9a9a9;\n    border-top-color: #000;\n    border-radius: 50%;\n  }\n\n  .border {\n    width: 100%;\n    transform: rotate(135deg);\n    animation: spin 1.3s steps(2) 0.2s infinite;\n    -webkit-animation: spin 1.3s linear infinite;\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  padding: 5px 20px;\n  border-radius: 50px;\n  cursor: pointer;\n  border: 1px solid ",
        ";\n  color: var(--white-color);\n  font-weight: 600;\n  font-size: 22px;\n  width: 120px;\n  height: 40px;\n  &:hover {\n    opacity: 0.8;\n  }\n  .image-user {\n    overflow: hidden;\n    margin: 0px;\n    padding: 0px;\n    border-radius: 50px;\n    object-fit: cover;\n    min-width: 25px;\n    width: 25px;\n    height: 25px;\n    border-radius: 50px;\n  }\n  .flex-center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .username {\n    font-size: 14px;\n    font-weight: 400;\n    text-transform: capitalize;\n    padding: 0px;\n    margin-left: 10px;\n  }\n  &.--blue {\n    background-color: ",
        ";\n    color: #fff;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









// import { PROVIDERS_MEMBER_AUTHO } from './WidgetLoginAuthO';


var MENU_LIST = [
    {
        id: "profile",
        nameTH: "ข้อมูลส่วนตัว",
        nameEN: "Profile",
        link: "/member/profile",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi/* HiOutlineUser */.HHH, {
            size: 16
        })
    },
    {
        id: "following",
        nameTH: "แท็กที่คุณสนใจ",
        nameEN: "Following",
        link: "/member/following",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md/* MdOutlineBookmarks */.ise, {
            size: 16
        })
    },
    {
        id: "signout",
        nameTH: "ออกจากระบบ",
        nameEN: "Sign out",
        link: "/",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi/* HiOutlineLogout */.cKt, {
            size: 16
        })
    }
];
var TEXT_LIST = [
    {
        nameTH: "เข้าสู่ระบบ",
        nameEN: "Login"
    },
    {
        nameTH: "เชื่อมต่อกับ",
        nameEN: "Login with"
    },
    {
        nameTH: "รายละเอียดเพิ่มเติม",
        nameEN: "more details"
    }
];
var PROVIDERS_MEMBER_AUTHO = function(NEXTAUTH_URL) {
    return [
        {
            provider: "google-oauth2",
            id: "google",
            name: "Google",
            type: "oauth",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fc/* FcGoogle */.JM8, {
                id: "google",
                size: 20
            }),
            signinUrl: "".concat(NEXTAUTH_URL, "/api/auth/signin/google"),
            callbackUrl: "".concat(NEXTAUTH_URL, "/api/auth/callback/google")
        },
        {
            provider: "line",
            id: "line",
            name: "Line",
            type: "oauth",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bs/* BsLine */.GF9, {
                id: "line",
                size: 20
            }),
            signinUrl: "".concat(NEXTAUTH_URL, "/api/auth/signin/line"),
            callbackUrl: "".concat(NEXTAUTH_URL, "/api/auth/callback/line")
        }
    ];
};
var WidgetLoginSubscribe = function(param) {
    var refKey = param.refKey, children = param.children, textButton = param.textButton, nextAuthUrl = param.nextAuthUrl, router = param.router, sendDataLayerGlobal = param.sendDataLayerGlobal, DATALAYER_TYPE = param.DATALAYER_TYPE, conditionDisabled = param.conditionDisabled, error = param.error, sessionSevId = param.sessionSevId, open = param.open, setOpen = param.setOpen, setError = param.setError, _key = param._key, _isEn = param.isEn, isEn = _isEn === void 0 ? false : _isEn, _isRemoveCookie = param.isRemoveCookie, isRemoveCookie = _isRemoveCookie === void 0 ? true : _isRemoveCookie, _redirectUrl = param.redirectUrl, redirectUrl = _redirectUrl === void 0 ? "" : _redirectUrl, className = param.className;
    var handleLogout = function handleLogout() {
        // ลบ Cookies ที่เกี่ยวข้องกับการล็อกอิน
        if (isRemoveCookie) {
            js_cookie/* default.remove */.Z.remove("login-data");
            localStorage.removeItem("login_channel");
            localStorage.removeItem("login-meta-data");
        }
        localStorage.removeItem("login-meta-data");
        js_cookie/* default.remove */.Z.remove("login-state");
        js_cookie/* default.remove */.Z.remove("login-redirect");
        window.location.href = "/api/auth/logout";
    // เปลี่ยนเส้นทางไปยังหน้าออกจากระบบของ Auth0
    };
    if (lodash_default().isEmpty(PROVIDERS_MEMBER_AUTHO(nextAuthUrl))) return null;
    var ref = (0,react.useState)(null), cookie = ref[0], setCookie = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    // const [auth0Client, setAuth0Client] = useState(null);
    (0,react.useEffect)(function() {
        setCookie(js_cookie/* default.get */.Z.get("login"));
    }, []);
    // handleCommemorate
    var handleLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item, index, redirectUrl) {
            var expiryDate, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setIsLoading(true);
                expiryDate = new Date();
                expiryDate.setMonth(expiryDate.getMonth() + 1);
                localStorage.setItem("login_channel", item === null || item === void 0 ? void 0 : item.provider);
                _tmp = {};
                sendDataLayerGlobal((_tmp.type = DATALAYER_TYPE.TRACK_INDEX, _tmp.router = router === null || router === void 0 ? void 0 : router.pathname, _tmp.section = "login", _tmp.data = {
                    heading: "เชื่อมต่อกับ ".concat(item === null || item === void 0 ? void 0 : item.id),
                    title: _key,
                    index: index + 1
                }, _tmp));
                _tmp1 = {};
                if (lodash_default().isEmpty(redirectUrl)) {
                    // console.log('#1');
                    window.location.href = "/api/auth/login?provider=".concat(item === null || item === void 0 ? void 0 : item.provider);
                } else {
                    // console.log('#2');
                    js_cookie/* default.set */.Z.set("login-redirect", redirectUrl, (_tmp1.expires = 1 / 1440, _tmp1.sameSite = "None", _tmp1.secure = true, _tmp1));
                    window.location.href = "/api/auth/login?provider=".concat(item === null || item === void 0 ? void 0 : item.provider, "&redirectUrl=").concat(redirectUrl);
                }
                return [
                    2
                ];
            });
        });
        return function handleLogin(item, index, redirectUrl) {
            return _ref.apply(this, arguments);
        };
    }();
    // console.log('WidgetLoginSubscribe', sessionSevId, refKey, sessionSevId?.picture);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetWrapper, {
        id: "widget-subscribe",
        children: !lodash_default().isEmpty(sessionSevId) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSubscribe, {
                    className: "button-subscribe ".concat(className),
                    isCommemorate: constants/* SHOW_COMMEMORATE */.WT === "true" ? "true" : constants/* SHOW_RIBBON */.zC,
                    style: {
                        filter: constants/* SHOW_RIBBON */.zC === "true" || constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
                    },
                    onClick: function() {
                        if (refKey === "subscribe") {
                            window.location.href = redirectUrl;
                            sendDataLayerGlobal({
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                position: "on:header",
                                section: "login",
                                data: {
                                    title: _key,
                                    heading: "open-login"
                                }
                            });
                        } else {
                            sendDataLayerGlobal({
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                position: "on:header",
                                section: "login",
                                data: {
                                    title: _key,
                                    heading: "open-login"
                                }
                            });
                        }
                    },
                    children: refKey === "subscribe" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: textButton
                    }) : !lodash_default().isEmpty(sessionSevId === null || sessionSevId === void 0 ? void 0 : sessionSevId.picture) && typeof (sessionSevId === null || sessionSevId === void 0 ? void 0 : sessionSevId.picture) === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "image-user",
                                src: sessionSevId === null || sessionSevId === void 0 ? void 0 : sessionSevId.picture,
                                width: 30,
                                height: 30,
                                title: "profile",
                                alt: "profile"
                            }),
                            (sessionSevId === null || sessionSevId === void 0 ? void 0 : sessionSevId.given_name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "username",
                                children: sessionSevId === null || sessionSevId === void 0 ? void 0 : sessionSevId.given_name
                            })
                        ]
                    }) : null
                }),
                refKey === "login" && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "menu-list",
                    style: {
                        filter: constants/* SHOW_RIBBON */.zC === "true" || constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
                    },
                    children: MENU_LIST.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                            children: item.id === "signout" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "list-item",
                                // href={item?.link}
                                // title={item.nameTH}
                                onClick: function() {
                                    sendDataLayerGlobal({
                                        type: DATALAYER_TYPE.TRACK_POSITION,
                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                        position: "on:header",
                                        section: "login",
                                        data: {
                                            title: (sessionSevId === null || sessionSevId === void 0 ? void 0 : sessionSevId.email) || _key,
                                            heading: item === null || item === void 0 ? void 0 : item.nameTH,
                                            index: index + 1
                                        }
                                    });
                                    handleLogout();
                                },
                                children: [
                                    item === null || item === void 0 ? void 0 : item.icon,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: isEn ? item === null || item === void 0 ? void 0 : item.nameEN : item === null || item === void 0 ? void 0 : item.nameTH
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "list-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: item === null || item === void 0 ? void 0 : item.link,
                                    title: item.nameTH,
                                    onClick: function() {
                                        sendDataLayerGlobal({
                                            type: DATALAYER_TYPE.TRACK_POSITION,
                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                            position: "on:header",
                                            section: "login",
                                            data: {
                                                title: (sessionSevId === null || sessionSevId === void 0 ? void 0 : sessionSevId.email) || _key,
                                                heading: item === null || item === void 0 ? void 0 : item.nameTH,
                                                index: index + 1
                                            }
                                        });
                                    },
                                    children: [
                                        item === null || item === void 0 ? void 0 : item.icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: isEn ? item === null || item === void 0 ? void 0 : item.nameEN : item === null || item === void 0 ? void 0 : item.nameTH
                                        })
                                    ]
                                })
                            })
                        }, index);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSubscribe, {
                    className: "button-subscribe ".concat(className),
                    isCommemorate: constants/* SHOW_COMMEMORATE */.WT === "true" ? "true" : constants/* SHOW_RIBBON */.zC,
                    style: {
                        filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                    },
                    onClick: function() {
                        sendDataLayerGlobal({
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router === null || router === void 0 ? void 0 : router.pathname,
                            position: "on:header",
                            section: "login",
                            data: {
                                title: _key,
                                heading: "open-login"
                            }
                        });
                        setOpen(true);
                    },
                    children: textButton
                }),
                open && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSocial, {
                    id: "widget-social",
                    style: {
                        filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-social",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn-close",
                                onClick: function() {
                                    if (open) {
                                        setError("");
                                        setOpen(false);
                                        sendDataLayerGlobal({
                                            type: DATALAYER_TYPE.TRACK_POSITION,
                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                            position: "on:header",
                                            section: "login",
                                            data: {
                                                title: _key,
                                                heading: "close-login"
                                            }
                                        });
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri/* RiCloseFill */.tgW, {
                                    size: 25
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "heading",
                                children: [
                                    " ",
                                    isEn ? TEXT_LIST[0].nameEN : TEXT_LIST[0].nameTH,
                                    " "
                                ]
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularLoadWrapper, {
                                className: "circle-loader",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "circle border"
                                })
                            }) : PROVIDERS_MEMBER_AUTHO(nextAuthUrl).map(function(item, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn-social ".concat(item.id ? "icon-".concat(item.id, " ").concat(conditionDisabled ? "disabled" : "") : ""),
                                        // disabled={conditionDisabled}
                                        onClick: function() {
                                            if (conditionDisabled) {
                                                setError("* กรุณายอมรับนโยบาย");
                                            } else {
                                                // Cookies.set('login', 'success', { expires: expiryDate, sameSite: 'None', secure: true }); // 1 Month
                                                handleLogin(item, index, redirectUrl);
                                            }
                                        },
                                        children: [
                                            item === null || item === void 0 ? void 0 : item.icon,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    !isEn ? TEXT_LIST[1].nameTH : TEXT_LIST[1].nameEN,
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            " ",
                                                            item === null || item === void 0 ? void 0 : item.id
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index)
                                });
                            }),
                            !lodash_default().isEmpty(error) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "error-label",
                                children: [
                                    " ",
                                    !conditionDisabled ? "" : error
                                ]
                            }),
                            !cookie && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    children,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "link-policy",
                                        href: "/privacy-policy",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: function() {
                                            return sendDataLayerGlobal({
                                                type: DATALAYER_TYPE.TRACK,
                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                section: "login",
                                                data: {
                                                    title: _key,
                                                    heading: "รายละเอียดเพิ่มเติม"
                                                }
                                            });
                                        },
                                        children: !isEn ? TEXT_LIST[2].nameTH : TEXT_LIST[2].nameEN
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var WidgetWrapper = styled_components_browser_esm["default"].div(widget_login_subscribe_templateObject());
var WidgetSocial = styled_components_browser_esm["default"].div(_templateObject1());
var CircularLoadWrapper = styled_components_browser_esm["default"].div(_templateObject2());
var ButtonSubscribe = styled_components_browser_esm["default"].div(_templateObject3(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isCommemorate) === "true" ? "#000000ff" : "#0040fd";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isCommemorate) === "true" ? "#000000ff" : "#0040fd";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isCommemorate) === "true" ? "#000000ff" : "#0040fd";
});

;// CONCATENATED MODULE: ./src/2.0/subscribe/button-subscribe.js
// import { useUser } from '@auth0/nextjs-auth0';
// import { WidgetLoginSubscribe } from '@nationgroup/nation-login-widgets';






// import { WidgetLoginSubscribe } from 'src/services/member-auth/components/widget-test';
// import { WidgetLoginSubscribe } from 'src/services/member-auth/components/widget-login-subscribe';




var button_subscribe_ButtonSubscribe = function(param) {
    var refKey = param.refKey, _text = param.text, text = _text === void 0 ? "" : _text, className = param.className, redirectUrl = param.redirectUrl;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), checkPDPA = ref2[0], setCheckPDPA = ref2[1];
    var ref3 = (0,react.useState)(false), checkCookies = ref3[0], setCheckCookies = ref3[1];
    var router = (0,next_router.useRouter)();
    var conditionDisabled = js_cookie/* default.get */.Z.get("login") === "success" ? false : !(checkPDPA && checkCookies);
    var nid = js_cookie/* default.get */.Z.get("_nid");
    var ga = js_cookie/* default.get */.Z.get("_ga");
    var _key = nid ? "".concat(ga, " : ").concat(nid) : "".concat(ga);
    var user = (0,useUser/* default */.Z)().user;
    //   const data = useUser();
    //   const [sessionSevId, setSessionSevId] = useState(null);
    //   const [sectionMember, setSectionMember] = useState({});
    //   useEffect(() => {
    //     const checkUser = async () => {
    //       if (!_.isEmpty(data) && !_.isEmpty(data?.user)) {
    //         const response = await fetch('/api/auth/metadata', {
    //           method: 'GET',
    //           headers: {
    //             'Content-Type': 'application/json'
    //           }
    //         });
    //         if (response.ok) {
    //           const res = await response.json();
    //           localStorage.setItem('login-meta-data', res);
    //           setSectionMember(decryptionClient(res));
    //         }
    //       }
    //     };
    //     const loginMetaData = localStorage.getItem('login-meta-data');
    //     const decryptLoginMetaData = !_.isEmpty(loginMetaData) ? decryptionClient(loginMetaData) : {};
    //     const expireCondition = !_.isEmpty(loginMetaData) ? new Date(decryptLoginMetaData?.expire) < new Date() : true;
    //     if (!_.isEmpty(data) && !_.isEmpty(data?.user)) {
    //       setSessionSevId(decryptionClient(data?.user));
    //       _.isEmpty(loginMetaData) || expireCondition ? checkUser() : setSectionMember(decryptLoginMetaData);
    //     }
    //   }, [data]);
    var decrypUser = user ? (0,decryption_payload/* decryptionClient */.F)(user) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetLoginSubscribe, {
            refKey: refKey,
            textButton: text,
            className: className,
            sendDataLayerGlobal: send_datalayer/* sendDataLayerGlobal */.dE,
            DATALAYER_TYPE: send_datalayer/* DATALAYER_TYPE */.$7,
            conditionDisabled: conditionDisabled,
            error: error,
            sessionSevId: decrypUser,
            open: open,
            setOpen: setOpen,
            setError: setError,
            router: router,
            _key: _key,
            nextAuthUrl: constants/* APP_URL */.FX,
            redirectUrl: redirectUrl,
            isRemoveCookie: true,
            loginStateExpire: Number(constants/* NEXT_PUBLIC_LOGIN_STATE_DATE */.KK),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_form, {
                    name: "pdpaConsent",
                    label: "นโยบายคุ้มครองข้อมูลส่วนบุคคล",
                    checked: checkPDPA,
                    onChange: function(e) {
                        return setCheckPDPA(e.target.checked);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_form, {
                    name: "cookieConsent",
                    label: "นโยบายคุ้มครองข้อมูลการใช้คุกกี้",
                    checked: checkCookies,
                    onChange: function(e) {
                        return setCheckCookies(e.target.checked);
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var button_subscribe = (button_subscribe_ButtonSubscribe);

;// CONCATENATED MODULE: ./src/2.0/subscribe/widget-subscribe.js

function widget_subscribe_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 15px;\n  &.--mobile {\n    display: block;\n    gap: 10px;\n\n    .button-subscribe {\n      margin: 5px 0;\n      padding: 5px 10px;\n      width: 100px;\n      justify-content: flex-end;\n      /* font-weight: 400;\n    font-size: 10px; */\n    }\n  }\n"
    ]);
    widget_subscribe_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var WidgetSubscribe = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(widget_subscribe_WidgetWrapper, {
            className: "button-subscribe ".concat(className),
            onClick: onClick,
            children: [
                !lodash_default().isEmpty(constants/* REDIRECT_MEMBER */.OF) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_subscribe, {
                    refKey: "subscribe",
                    className: "--blue",
                    text: "SUBSCRIBE",
                    redirectUrl: constants/* REDIRECT_MEMBER */.OF
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_subscribe, {
                    refKey: "login",
                    text: "Login"
                })
            ]
        })
    });
};
/* harmony default export */ var widget_subscribe = (WidgetSubscribe);
var widget_subscribe_WidgetWrapper = styled_components_browser_esm["default"].div(widget_subscribe_templateObject());

;// CONCATENATED MODULE: ./src/2.0/subscribe/header-subscribe.js

function header_subscribe_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  max-width: 1300px;\n  margin: auto;\n  padding: 0 10px;\n  .logo-img {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  .logo-header {\n    width: 100%;\n    max-width: 1280px;\n    min-height: 150px;\n    margin: auto;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 15px 15px 25px;\n    @media (max-width: 1024px) {\n      min-height: 90px;\n      margin: 10px 15px 9px;\n    }\n    h1 {\n      margin-bottom: 0;\n    }\n    a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n    }\n    span {\n      text-indent: 1000em;\n      white-space: nowrap;\n      overflow: hidden;\n      display: none !important;\n      // display: block;\n      position: fixed;\n      width: 100%;\n    }\n    .ribbon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 100%;\n      max-width: 100%;\n      img {\n        width: 70px;\n        height: 70px;\n      }\n      @media (max-width: 540px) {\n        img {\n          width: 50px;\n          height: 50px;\n        }\n      }\n    }\n    .logo {\n      display: block;\n      width: 420px;\n      max-width: 100%;\n      height: auto;\n\n      @media (max-width: 540px) {\n        width: 320px;\n      }\n    }\n  }\n"
    ]);
    header_subscribe_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var HeaderSubscribe = function(param) {
    var sessionSevId = param.sessionSevId;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_subscribe_WidgetWrapper, {
            className: "header-subscribe",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "logo-header",
                    children: router.asPath === "/" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "ข่าวล่าสุด วิเคราะห์ข่าวเศรษฐกิจ - กรุงเทพธุรกิจ "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "logo-img",
                                href: "/",
                                title: "กรุงเทพธุรกิจ",
                                "aria-label": "หน้าแรก กรุงเทพธุรกิจ",
                                //! DATALAYER
                                onClick: function() {
                                    return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                        type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                        position: "on:header",
                                        section: "header",
                                        data: {
                                            title: "logo",
                                            heading: "logo"
                                        }
                                    });
                                },
                                children: [
                                    constants/* SHOW_RIBBON */.zC === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ribbon",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(constants/* APP_IMG */.T, "/logo-ribbon-black-2.png"),
                                            alt: "กรุงเทพธุรกิจ",
                                            width: "35px",
                                            height: "35px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "logo",
                                        src: "".concat(constants/* APP_IMG */.T, "/new-logo-primary.webp"),
                                        alt: "กรุงเทพธุรกิจ",
                                        width: "400",
                                        height: "100",
                                        style: {
                                            width: "100%",
                                            maxWidth: "400px",
                                            height: "auto",
                                            aspectRatio: "400/100",
                                            filter: constants/* SHOW_RIBBON */.zC === "true" ? "brightness(0)" : constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(1)" : "unset"
                                        }
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/",
                        className: "logo-img",
                        "aria-label": "หน้าแรก กรุงเทพธุรกิจ",
                        //! DATALAYER
                        onClick: function() {
                            return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                position: "on:header",
                                section: "header",
                                data: {
                                    title: "logo",
                                    heading: "logo"
                                }
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "logo",
                            src: "".concat(constants/* APP_IMG */.T, "/new-logo-primary.webp"),
                            alt: "กรุงเทพธุรกิจ",
                            width: "400",
                            height: "100",
                            style: {
                                width: "100%",
                                maxWidth: "400px",
                                height: "auto",
                                aspectRatio: "400/100",
                                filter: constants/* SHOW_RIBBON */.zC === "true" ? "brightness(0)" : constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(1)" : "unset"
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_subscribe, {
                    sessionSevId: sessionSevId
                })
            ]
        })
    });
};
/* harmony default export */ var header_subscribe = (HeaderSubscribe);
var header_subscribe_WidgetWrapper = styled_components_browser_esm["default"].div(header_subscribe_templateObject());

// EXTERNAL MODULE: ./src/services/member-auth/constants/index.jsx
var member_auth_constants = __webpack_require__(30811);
;// CONCATENATED MODULE: ./src/components/layouts/header.js




function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.header-desktop {\n    min-height: 45px;\n    border-top: 6px solid var(--border-gray);\n    border-bottom: 1px solid ",
        ";\n    box-shadow: var(--box-shadow-header);\n\n    background-color: var(--white-color);\n    color: var(--text-color);\n    font-family: 'DBHelvethaica', sans-serif;\n    padding: 3px 0;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    ul {\n      display: flex;\n      align-items: baseline;\n      list-style: none;\n      margin-bottom: 0;\n      padding-left: 20px;\n\n      li {\n        margin: 5px;\n        font-weight: bold;\n        cursor: pointer;\n\n        img {\n          max-height: 20px;\n          width: auto;\n        }\n\n        &:hover {\n          color: var(--secondary-gray);\n        }\n\n        a {\n          color: var(--text-color);\n          text-decoration: none;\n\n          &:hover {\n            color: var(--secondary-gray);\n          }\n\n          h2 {\n            font-size: inherit;\n            margin-bottom: 0;\n            line-height: inherit;\n          }\n\n          /* svg {\n          path {\n            &:hover {\n              fill: var(--secondary-gray);\n            }\n          }\n        } */\n        }\n      }\n    }\n    @media (max-width: 475px) {\n      min-height: 47px;\n    }\n    ul {\n      &.--desktop {\n        justify-content: space-between;\n        padding: 0;\n        li {\n          position: relative;\n          font-size: 20px;\n          font-weight: 200;\n          padding: 0px 5px;\n          a {\n            font-weight: 300;\n            color: var(--text-color);\n            &:hover {\n              color: ",
        ";\n            }\n          }\n          svg {\n            margin: 0 0 2px 2px;\n          }\n          &.active {\n            > a {\n              color: ",
        ";\n              font-weight: 300;\n            }\n            a {\n              &:hover {\n                border-bottom: none;\n              }\n              ul {\n                a {\n                  color: var(--softblack-color);\n                  &:hover {\n                    color: var(--white-color);\n                  }\n                }\n              }\n            }\n          }\n        }\n        @media (max-width: 1200px) {\n          li {\n            font-size: 16px;\n          }\n        }\n        @media (max-width: 1080px) {\n          display: none;\n        }\n      }\n    }\n\n    .mobile-menu {\n      display: none;\n\n      &.--close {\n        background: transparent;\n        border: none;\n      }\n      @media (max-width: 1080px) {\n        display: block;\n        padding: 8px 24px;\n        background-color: #e6e6e6;\n        color: #0600e7;\n        margin: -3px 0;\n        font-size: 16px;\n        border: none;\n        outline: none;\n        overflow: unset;\n\n        svg {\n          margin-bottom: 8px;\n        }\n        // &:hover {\n        //   color: #fff;\n        //   background-color: #0600E7;\n        // }\n\n        &.--close {\n          background-color: #ec1818;\n          color: #fff;\n\n          &:hover {\n            color: #fff;\n            background-color: #2a2a2a;\n          }\n        }\n      }\n    }\n  }\n  @media (max-width: 1080px) {\n    display: none;\n  }\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  font-family: 'DBHelvethaica', sans-serif;\n  background-color: #fff;\n  color: #000;\n  margin: auto;\n  padding: 0px;\n  align-items: center;\n  z-index: 25;\n"
    ]);
    header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #ffff;\n  color: var(--text-color);\n  position: absolute;\n  z-index: 1001;\n  top: 70px;\n  left: 0;\n  width: 100%;\n  box-shadow: 2px 5px 7px rgba(0, 0, 0, 0.1);\n\n  &.--mobile {\n    width: 100%;\n  }\n\n  ul {\n    max-width: 1280px;\n    margin: auto;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 5px 0px;\n\n    li {\n      a {\n        color: var(--text-color);\n        font-weight: 400;\n        font-size: 22px;\n      }\n    }\n\n    &.mobile {\n      position: relative;\n      padding: 15px;\n      overflow-y: scroll;\n\n      li {\n        //display: flex;\n        //justify-content: space-between;\n        width: 100%;\n        margin-bottom: 15px;\n        color: #fff;\n        border-bottom: 1px solid ",
        ";\n        list-style-type: none;\n\n        &:hover {\n          a {\n            color: #909090;\n          }\n        }\n\n        svg {\n          float: right;\n          background-color: #fff;\n          color: ",
        ";\n        }\n\n        .expand-sub-mobile {\n          ul {\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            justify-content: flex-start;\n            margin: 0px auto;\n            &:hover {\n              color: #2f2f2f;\n            }\n            padding-left: 40px;\n\n            li {\n              width: auto;\n              padding: 3px 15px;\n              border-bottom: none;\n              border-radius: 6px;\n              margin: 3px 6px;\n              font-weight: 400;\n              background-color: var(--primary-color);\n              color: #ffff;\n              list-style-type: none;\n              &:hover {\n                color: #fff;\n                background: #000;\n\n                a {\n                  color: #fff;\n                }\n              }\n\n              a {\n                color: #fff;\n                font-size: 16px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &.--hide {\n    display: none;\n  }\n"
    ]);
    header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  /* กำหนดขนาดคงที่ทุก viewport ตั้งแต่ render แรก ป้องกัน CLS */\n  .logo {\n    width: 170px;\n    max-width: 100%;\n    height: auto;\n    aspect-ratio: 170 / 43;\n  }\n  .logo-img {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  .show-mobile {\n    display: block !important;\n    overflow-x: hidden;\n    @media (min-width: 1080px) {\n      display: none !important;\n    }\n    #widget-login {\n      padding-left: 0;\n    }\n  }\n  .widget-login-wrapper {\n    @media (max-width: 1080px) {\n      overflow: unset;\n    }\n  }\n\n  .btn-login {\n    margin-top: 3px;\n    svg {\n      color: var(--primary-color);\n      &:hover {\n        color: var(--primary-color);\n      }\n    }\n  }\n\n  .body-close {\n    display: flex;\n    justify-content: right;\n  }\n  .--close {\n    border: none;\n    background-color: rgb(255, 255, 255);\n    font-size: 28px;\n    padding: 10px;\n    svg {\n      padding: 0 !important;\n      color: var(--secondary-gray) !important;\n    }\n  }\n  @media (max-width: 1080px) {\n    display: grid;\n    grid-template-columns: 1fr 2fr 1fr;\n    grid-template-areas: 'block-1 block-2 block-3';\n    position: sticky;\n    top: 0;\n    width: 100vw;\n    background-color: var(--white-color);\n    box-shadow: 0px 4px 10px 0px var(--border-gray);\n\n    justify-content: space-around;\n    align-items: center;\n    z-index: 100;\n    min-height: 70px;\n    .logo {\n      /* filter: brightness(0) invert(1); */\n      margin: 10px 0px;\n    }\n    .block-1 {\n      grid-area: block-1;\n      background: transparent;\n      border: unset;\n      display: flex;\n      justify-content: flex-start;\n      padding-left: 10px;\n\n      svg {\n        color: var(--secondary-gray);\n        font-size: 24px;\n      }\n    }\n    .block-2 {\n      grid-area: block-2;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    .block-3 {\n      grid-area: block-3;\n      display: flex;\n      justify-content: flex-end;\n      padding-right: 5px;\n      align-items: center;\n      .button-subscribe {\n        background: transparent;\n        border: unset;\n        color: var(--secondary-gray);\n        width: auto;\n      }\n    }\n  }\n"
    ]);
    header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

















// import { getSession } from '@auth0/nextjs-auth0';
// const WidgetLogin = dynamic(import('src/services/member-auth/components/widget-login'));
var WidgetFollow = dynamic_default()(__webpack_require__.e(/* import() */ 4706).then(__webpack_require__.bind(__webpack_require__, 24706)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24706)
            ];
        }
    }
});
var CardSubMenu = dynamic_default()(__webpack_require__.e(/* import() */ 8050).then(__webpack_require__.bind(__webpack_require__, 28050)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28050)
            ];
        }
    }
});
dayjs_min_default().extend((buddhistEra_default()));
function useOnClickOutsideExpand(ref, handler) {
    (0,react.useEffect)(function() {
        var listener = function(event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mouseleave", listener);
        return function() {
            document.removeEventListener("mouseleave", listener);
        };
    }, [
        ref,
        handler
    ]);
}
function useOnClickOutsideExpandSub(ref, handler) {
    (0,react.useEffect)(function() {
        var listener = function(event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mouseleave", listener);
        return function() {
            document.removeEventListener("mouseleave", listener);
        };
    }, [
        ref,
        handler
    ]);
}
function useOnClickOutsideMoreMenu(ref, handler) {
    (0,react.useEffect)(function() {
        var listener = function(event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return function() {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [
        ref,
        handler
    ]);
}
function useOnClickOutsideSearch(ref, handler) {
    (0,react.useEffect)(function() {
        var listener = function(event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return function() {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [
        ref,
        handler
    ]);
}
var Header = function(param) {
    var data = param.data;
    var newNavData = [];
    if (data === null) newNavData = new Array(11).fill("");
    var router = (0,next_router.useRouter)();
    var searchBoxRef = (0,react.useRef)();
    var recaptchaRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), toggleSearch = ref[0], setToggleSearch = ref[1];
    var ref1 = (0,react.useState)(null), textSearch = ref1[0], setTextSearch = ref1[1];
    var ref2 = (0,react.useState)(false), recaptchaBox = ref2[0], setRecaptchaBox = ref2[1];
    var ref3 = (0,react.useState)({
        status: false,
        key: null
    }), subToggle = ref3[0], setSubToggle = ref3[1];
    var ref4 = (0,react.useState)({
        status: false,
        key: null
    }), subToggleMoreMenu = ref4[0], setSubToggleMoreMenu = ref4[1];
    var ref5 = (0,react.useState)(true), moreMenu = ref5[0], setMoreMenu = ref5[1];
    var ref6 = (0,react.useState)(false), expandMobile = ref6[0], setExpandMobile = ref6[1];
    var expandBoxRef = (0,react.useRef)();
    var subExpandBoxRef = (0,react.useRef)();
    var moreMenuBoxRef = (0,react.useRef)();
    // const userAuth = useUser();
    // const session = getSession(context.req, context.res);
    // console.log('getSession :', getSession);
    useOnClickOutsideExpand(expandBoxRef, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        setSubToggle((_tmp.status = false, _tmp.key = null, _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }));
    useOnClickOutsideExpandSub(subExpandBoxRef, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        setSubToggleMoreMenu((_tmp.status = false, _tmp.key = null, _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }));
    useOnClickOutsideMoreMenu(moreMenuBoxRef, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        setMoreMenu(true)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        setExpandMobile(false)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }));
    useOnClickOutsideSearch(searchBoxRef, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        setToggleSearch(false)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }));
    var handleSearch = function(e) {
        e.preventDefault();
        setRecaptchaBox(true);
    };
    var onReCAPTCHAChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(captchaCode) {
            var response, _tmp, serachParams, _tmp1, params, _tmp2, error, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!captchaCode) return [
                            2,
                            null
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _tmp = {};
                        return [
                            4,
                            fetch("/api/search/recaptcha", (_tmp.method = "POST", _tmp.body = JSON.stringify({
                                textSearch: textSearch,
                                captcha: captchaCode
                            }), _tmp.headers = {
                                "Content-Type": "application/json"
                            }, _tmp))
                        ];
                    case 2:
                        response = _state.sent();
                        if (!response.ok) return [
                            3,
                            3
                        ];
                        setRecaptchaBox(false);
                        _tmp1 = {};
                        serachParams = (_tmp1.q = textSearch || "", _tmp1);
                        _tmp2 = {};
                        params = lib_default().stringify(serachParams, (_tmp2.encodeValuesOnly = true, _tmp2.arrayFormat = "brackets", _tmp2));
                        window.location.href = "/search?".concat(params);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            response.json()
                        ];
                    case 4:
                        error = _state.sent();
                        throw new Error(error.message);
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        alert((err === null || err === void 0 ? void 0 : err.message) || "Something went wrong");
                        setRecaptchaBox(false);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        recaptchaRef.current = null;
                        setTextSearch(null);
                        setRecaptchaBox(false);
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function onReCAPTCHAChange(captchaCode) {
            return _ref.apply(this, arguments);
        };
    }();
    var cloneNavData = [];
    if (data !== null) {
        cloneNavData = (0,_to_consumable_array/* default */.Z)(data);
        newNavData = cloneNavData.splice(0, 13);
    }
    var dateNow = dayjs_min_default()(new Date()).locale("th").format("วันdddd ที่ D MMMM BBBB ");
    var cid = router.query.cid;
    // let dataNav = newNavData.filter(el => el.nameEng === 'news');
    // dataNav = dataNav[0]?.sub.concat({
    //   id: 0,
    //   nameTh: 'ข่าวทั้งหมด',
    //   nameEng: 'latest-news',
    //   link: '/category/latest-news',
    //   metaData: null,
    //   data: []
    // });
    // newNavData = newNavData.map(el => {
    //   if (el.nameEng === 'news') {
    //     return { ...el, sub: dataNav.sort((a, b) => a.id - b.id) };
    //   }
    //   return el;
    // });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "default-header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrapper, {
                    gray: constants/* SHOW_RIBBON */.zC === "true",
                    className: "header-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "top-header-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "top-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "top-header-settrade",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: dateNow
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetFollow, {
                                            //! DATALAYER
                                            eventDataLayer: {
                                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                position: "on:header",
                                                section: "header"
                                            },
                                            handleSearch: function() {
                                                setToggleSearch(!toggleSearch);
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "header-wrap ".concat(constants/* SHOW_RIBBON */.zC === "true" ? "back-white" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_subscribe, {})
                            }),
                            toggleSearch && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "search-box-popup is-gray",
                                style: {
                                    filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                },
                                children: [
                                    recaptchaBox && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "recaptcha-box",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm, {
                                            ref: recaptchaRef,
                                            sitekey: constants/* RECAPTCHA_SITE_KEY */.OL,
                                            onChange: onReCAPTCHAChange
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: handleSearch,
                                        className: "search-box-input",
                                        ref: searchBoxRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                maxLength: 150,
                                                onChange: function(e) {
                                                    return setTextSearch(e.target.value);
                                                },
                                                className: "search-input",
                                                placeholder: "ค้นหา"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "submit",
                                                "aria-label": "Search Submit",
                                                className: "search-submit",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaSearch */.U41, {
                                                    size: 24
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderDesktop, {
                className: "header-desktop",
                isCommemorate: constants/* SHOW_COMMEMORATE */.WT === "true" ? "true" : constants/* SHOW_RIBBON */.zC,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row col-12 align-self-center justify-content-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 align-self-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                    className: "row justify-content-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "--desktop col-12",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "".concat(router.asPath === "/" ? "active" : ""),
                                                    onMouseOver: function() {
                                                        setSubToggle({
                                                            status: false,
                                                            key: null
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/",
                                                        "aria-label": "กรุงเทพธุรกิจ",
                                                        title: "กรุงเทพธุรกิจ",
                                                        //! DATALAYER
                                                        onClick: function() {
                                                            return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                position: "on:header",
                                                                section: "header",
                                                                data: {
                                                                    title: "กรุงเทพธุรกิจ",
                                                                    heading: "กรุงเทพธุรกิจ"
                                                                }
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "logo",
                                                            src: "".concat(constants/* APP_IMG */.T, "/logo-primary.png"),
                                                            alt: "logo",
                                                            width: "100%",
                                                            height: "100%",
                                                            style: {
                                                                filter: constants/* SHOW_RIBBON */.zC === "true" ? "brightness(0)" : constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(1)" : "unset"
                                                            }
                                                        })
                                                    })
                                                }),
                                                newNavData.map(function(item, i) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                        className: "".concat(item && cid === item.nameEng ? "active" : ""),
                                                        style: {
                                                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                                        },
                                                        children: item.sub.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    style: {
                                                                        position: "relative"
                                                                    },
                                                                    href: "/".concat(item.link),
                                                                    title: item === null || item === void 0 ? void 0 : item.nameTh,
                                                                    onMouseOver: function() {
                                                                        setSubToggle({
                                                                            status: true,
                                                                            key: i
                                                                        });
                                                                        setSubToggleMoreMenu({
                                                                            status: false,
                                                                            key: null
                                                                        });
                                                                    },
                                                                    //! DATALAYER
                                                                    onClick: function() {
                                                                        return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                                            type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                            position: "on:header",
                                                                            section: "header",
                                                                            data: {
                                                                                title: item === null || item === void 0 ? void 0 : item.nameTh,
                                                                                heading: item === null || item === void 0 ? void 0 : item.nameTh
                                                                            }
                                                                        });
                                                                    },
                                                                    children: [
                                                                        item.nameTh,
                                                                        item.sub.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaAngleDown */.iUH, {
                                                                            size: 14
                                                                        })
                                                                    ]
                                                                }, i),
                                                                (subToggle === null || subToggle === void 0 ? void 0 : subToggle.status) && (subToggle === null || subToggle === void 0 ? void 0 : subToggle.key) === i && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "expand-sub ".concat(i > 5 ? "--right" : "--default"),
                                                                    ref: expandBoxRef,
                                                                    onMouseLeave: function() {
                                                                        return setSubToggle({
                                                                            key: null,
                                                                            status: false
                                                                        });
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSubMenu, {
                                                                        data: item === null || item === void 0 ? void 0 : item.sub,
                                                                        heading: item === null || item === void 0 ? void 0 : item.nameTh,
                                                                        //! DATALAYER
                                                                        eventDataLayer: {
                                                                            type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                            position: "ใน:menubar",
                                                                            section: "header"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "/".concat(item.link),
                                                            onMouseOver: function() {
                                                                return setSubToggle({
                                                                    status: false,
                                                                    key: null
                                                                });
                                                            },
                                                            //! DATALAYER
                                                            onClick: function() {
                                                                return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                                    type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                    router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                    position: "on:header",
                                                                    section: "header",
                                                                    data: {
                                                                        title: item === null || item === void 0 ? void 0 : item.nameTh,
                                                                        heading: item === null || item === void 0 ? void 0 : item.nameTh
                                                                    }
                                                                });
                                                            },
                                                            children: item.nameTh
                                                        })
                                                    }, i);
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "col-auto mobile-menu",
                                            style: {
                                                filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                            },
                                            onClick: function() {
                                                setMoreMenu(!moreMenu);
                                                setExpandMobile(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaGripHorizontal */.eNL, {})
                                        }),
                                        expandMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "col-auto mobile-menu --close",
                                            style: {
                                                filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                            },
                                            onClick: function() {
                                                return setExpandMobile(false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaTimes */.aHS, {})
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-auto mobile-menu show-mobile widget-login-wrapper",
                                            children: member_auth_constants/* SHOW_MEMBER */.SP === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_subscribe, {})
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "expand-more-menu ".concat(moreMenu ? "--hide" : "", " ").concat(expandMobile ? "--mobile" : ""),
                        ref: moreMenuBoxRef,
                        children: expandMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "mobile",
                            children: !lodash_default().isEmpty(newNavData) && newNavData.map(function(item, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                    },
                                    onClick: function() {
                                        setSubToggleMoreMenu({
                                            status: true,
                                            key: i
                                        });
                                        setSubToggle({
                                            status: false,
                                            key: null
                                        });
                                    },
                                    children: item.sub.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/".concat(item.link),
                                                //! DATALAYER
                                                onClick: function() {
                                                    return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                        type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                                        position: "on:header",
                                                        section: "header",
                                                        data: {
                                                            title: item === null || item === void 0 ? void 0 : item.nameTh,
                                                            heading: "".concat(item === null || item === void 0 ? void 0 : item.nameTh)
                                                        }
                                                    });
                                                },
                                                children: item.nameTh
                                            }, i),
                                            item.sub.length > 0 && subToggleMoreMenu.status && subToggleMoreMenu.key === i ? /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaAngleUp */.$Pg, {
                                                size: 12,
                                                onClick: function() {
                                                    return setSubToggleMoreMenu({
                                                        key: null,
                                                        status: false
                                                    });
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaAngleDown */.iUH, {
                                                size: 12
                                            }),
                                            subToggleMoreMenu.status && subToggleMoreMenu.key === i ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "expand-sub-mobile",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    children: item.sub.map(function(subMenu, index) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: subMenu.link,
                                                                //! DATALAYER
                                                                onClick: function() {
                                                                    return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                                        type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                        position: "on:header",
                                                                        section: "header",
                                                                        data: {
                                                                            title: subMenu === null || subMenu === void 0 ? void 0 : subMenu.nameTh,
                                                                            heading: "".concat(item === null || item === void 0 ? void 0 : item.nameTh, ":").concat(subMenu === null || subMenu === void 0 ? void 0 : subMenu.nameTh)
                                                                        }
                                                                    });
                                                                },
                                                                children: subMenu.nameTh
                                                            })
                                                        }, index);
                                                    })
                                                })
                                            }) : null
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/".concat(item.link),
                                        //! DATALAYER
                                        onClick: function() {
                                            return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                position: "on:header",
                                                section: "header",
                                                data: {
                                                    title: item === null || item === void 0 ? void 0 : item.nameTh,
                                                    heading: "".concat(item === null || item === void 0 ? void 0 : item.nameTh)
                                                }
                                            });
                                        },
                                        children: item.nameTh
                                    })
                                }, i);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderMoblie, {
                className: "header-mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block-1",
                        style: {
                            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                        },
                        onClick: function() {
                            setMoreMenu(!moreMenu);
                            setExpandMobile(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaBars */.Fm7, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/",
                        className: "block-2",
                        title: "กรุงเทพธุรกิจ",
                        //! DATALAYER
                        onClick: function() {
                            return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                position: "on:header",
                                section: "header",
                                data: {
                                    title: "logo",
                                    heading: "logo"
                                }
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "logo",
                            src: "".concat(constants/* APP_IMG */.T, "/new-logo-primary.svg"),
                            alt: "logo",
                            width: 170,
                            height: 43,
                            fetchpriority: "high",
                            decoding: "async",
                            style: {
                                filter: constants/* SHOW_RIBBON */.zC === "true" ? "brightness(0)" : constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(1)" : "unset"
                            }
                        })
                    }),
                    expandMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "body-close",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "col-auto mobile-menu --close",
                            onClick: function() {
                                return setExpandMobile(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaTimes */.aHS, {})
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_subscribe, {
                        className: "block-3 --mobile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore, {
                        isCommemorate: constants/* SHOW_COMMEMORATE */.WT === "true" ? "true" : constants/* SHOW_RIBBON */.zC,
                        className: "expand-more-menu ".concat(moreMenu ? "--hide" : "", " ").concat(expandMobile ? "--mobile" : ""),
                        ref: moreMenuBoxRef,
                        children: expandMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "mobile",
                            children: !lodash_default().isEmpty(newNavData) && newNavData.map(function(item, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : ""
                                    },
                                    onClick: function() {
                                        setSubToggleMoreMenu({
                                            status: true,
                                            key: i
                                        });
                                        setSubToggle({
                                            status: false,
                                            key: null
                                        });
                                    },
                                    children: item.sub.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/".concat(item.link),
                                                //! DATALAYER
                                                onClick: function() {
                                                    return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                        type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                                        position: "on:header",
                                                        section: "header",
                                                        data: {
                                                            title: item === null || item === void 0 ? void 0 : item.nameTh,
                                                            heading: "".concat(item === null || item === void 0 ? void 0 : item.nameTh)
                                                        }
                                                    });
                                                },
                                                children: item.nameTh
                                            }, i),
                                            item.sub.length > 0 && subToggleMoreMenu.status && subToggleMoreMenu.key === i ? /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaAngleUp */.$Pg, {
                                                size: 16,
                                                onClick: function() {
                                                    return setSubToggleMoreMenu({
                                                        key: null,
                                                        status: false
                                                    });
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(fa/* FaAngleDown */.iUH, {
                                                size: 16
                                            }),
                                            subToggleMoreMenu.status && subToggleMoreMenu.key === i ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "expand-sub-mobile",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    children: item.sub.map(function(subMenu, index) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            style: {
                                                                filter: constants/* SHOW_RIBBON */.zC === "true" || constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: subMenu.link,
                                                                //! DATALAYER
                                                                onClick: function() {
                                                                    return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                                        type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                        position: "on:header",
                                                                        section: "header",
                                                                        data: {
                                                                            title: subMenu === null || subMenu === void 0 ? void 0 : subMenu.nameTh,
                                                                            heading: "".concat(item === null || item === void 0 ? void 0 : item.nameTh, ":").concat(subMenu === null || subMenu === void 0 ? void 0 : subMenu.nameTh)
                                                                        }
                                                                    });
                                                                },
                                                                children: subMenu.nameTh
                                                            })
                                                        }, index);
                                                    })
                                                })
                                            }) : null
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/".concat(item.link),
                                        //! DATALAYER
                                        onClick: function() {
                                            return (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                position: "on:header",
                                                section: "header",
                                                data: {
                                                    title: item === null || item === void 0 ? void 0 : item.nameTh,
                                                    heading: "".concat(item === null || item === void 0 ? void 0 : item.nameTh)
                                                }
                                            });
                                        },
                                        children: item.nameTh
                                    })
                                }, i);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var HeaderDesktop = styled_components_browser_esm["default"].div(header_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isCommemorate) === "true" ? "#ababacff" : "var(--primary-color)";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isCommemorate) === "true" ? "#959596ff" : "var(--secondary-color)";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isCommemorate) === "true" ? "#000000ff" : "var(--primary-color)";
});
var HeaderWrapper = styled_components_browser_esm["default"].header(header_templateObject1());
var ExpandMore = styled_components_browser_esm["default"].div(header_templateObject2(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isCommemorate) === "true" ? "#1c1c1cff" : "var(--primary-color)";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isCommemorate) === "true" ? "#1c1c1cff" : "var(--primary-color)";
});
var HeaderMoblie = styled_components_browser_esm["default"].div(header_templateObject3());
/* harmony default export */ var header = (Header);


/***/ }),

/***/ 51148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* eslint-disable no-unused-vars */ 





function useUser() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), result = ref[0], setResult = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref2[0], setError = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isLogin = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-state");
        var cookies = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
        var getUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var response, _tmp, _tmp1, res, _tmp2, _tmp3, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                6,
                                7
                            ]);
                            _tmp = {};
                            return [
                                4,
                                fetch("/api/auth/me", (_tmp.method = "GET", _tmp.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!(!response.ok || response.status === 204 || response.statusText === "No Content")) return [
                                3,
                                2
                            ];
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove("login-state");
                            _tmp1 = {};
                            setResult(_tmp1);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            res = _state.sent();
                            _tmp2 = {};
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set("login-data", res, (_tmp2.secure = true, _tmp2.expires = Number(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_PUBLIC_LOGIN_COOKIE_DATE */ .B6), _tmp2)); //, { expires: 1, sameSite: 'strict', secure: true, httpOnly: true }
                            _tmp3 = {};
                            setResult((_tmp3.user = res, _tmp3));
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                7
                            ];
                        case 5:
                            error = _state.sent();
                            setError(error);
                            return [
                                3,
                                7
                            ];
                        case 6:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getUser() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && !lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            var cook = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
            setResult({
                user: cook
            });
        } else if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            getUser();
        }
    }, []);
    return result;
}
/* harmony default export */ __webpack_exports__["Z"] = (useUser);


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ api; }
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ })

}]);